import { render, staticRenderFns } from "./CropmarketalaysisForYear.vue?vue&type=template&id=5826ba5d&"
import script from "./CropmarketalaysisForYear.vue?vue&type=script&lang=js&"
export * from "./CropmarketalaysisForYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports